import {
  accountingFirmPermission,
  atcCollabPermission,
  banksPermissions,
  cpCollabPermission,
  directorPermission,
  displayFeedPermission,
  helpdeskPermission,
  updateProfilePermission,
  usersPermissions,
} from "./RequiredPermissions/general";
import useCheckPermissions from "./useCheckPermissions";

export default function useGeneralPermissions() {
  const canUpdateProfile = useCheckPermissions(updateProfilePermission);
  const canDisplayAllUsers = useCheckPermissions(usersPermissions.displayAllUsers);
  const canCreateUser = useCheckPermissions(usersPermissions.create);
  const canUpdateUser = useCheckPermissions(usersPermissions.update);
  const canDisplayUser = useCheckPermissions(usersPermissions.display);
  const canDisplayFeed = useCheckPermissions(displayFeedPermission);
  const canViewBanks = useCheckPermissions(banksPermissions.viewBanksList);
  const canCreateBank = useCheckPermissions(banksPermissions.createBank);
  const canUpdateBank = useCheckPermissions(banksPermissions.updateBank);
  const canDeleteBank = useCheckPermissions(banksPermissions.deleteBank);
  const isCpCollab = useCheckPermissions(cpCollabPermission);
  const isAtcCollab = useCheckPermissions(atcCollabPermission);
  const isAccountingFirm = useCheckPermissions(accountingFirmPermission);
  const isDirector = useCheckPermissions(directorPermission);
  const isHelpdesk = useCheckPermissions(helpdeskPermission);

  return {
    canCreateBank,
    canUpdateBank,
    canDeleteBank,
    canUpdateProfile,
    canDisplayAllUsers,
    canDisplayUser,
    canDisplayFeed,
    canCreateUser,
    canUpdateUser,
    canViewBanks,
    isCpCollab,
    isAtcCollab,
    isAccountingFirm,
    isDirector,
    isHelpdesk,
  };
}
